import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { getListingFullAddressString } from 'common/listingHelpers';

import { createFormValidationFn } from 'client/helpers/formikHelpers';

import { cleanMarketingPartnerListingFormValues } from 'common/marketingPartnerListingHelpers';

import { SR_API_ACTION_PARTNER_UPDATE_MARKETING_LISTING } from 'api/actionTypes';

import { MARKETING_PARTNER_LISTING_STATUS_IN_PROGRESS } from 'common/marketingPartnerListingConstants';

import log from 'client/lib/log';

import postWithState from 'client/actions/postWithState';

import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';
import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrPartnerPageV2, {
  SR_PARTNER_PAGE_V2_FONT_SIZE_SMALL,
} from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrStaticFooter from 'client/components/SrStaticFooter';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFooterButton from 'client/components/SrFooterButton/SrFooterButton';

class SrPartnerBringBackOnMarketForm extends Component {
  static propTypes = {
    partner: PropTypes.object.isRequired,
    marketingPartnerListing: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      shouldShowSuccessModal: false,
      shouldShowLoadingScreen: false,
    };
  }

  _onSubmit = (formValues) => {
    const { partner, marketingPartnerListing, dispatch, onSubmit } = this.props;
    const partnerMarketingNotes = marketingPartnerListing.partnerMarketingNotes;
    const updates = cleanMarketingPartnerListingFormValues({
      ...marketingPartnerListing,
      ...formValues,
      status: MARKETING_PARTNER_LISTING_STATUS_IN_PROGRESS,
      partnerId: partner.id,
      partnerMarketingNotes: partnerMarketingNotes
        ? formValues.partnerMarketingNotes
          ? partnerMarketingNotes + `\n\n${formValues.partnerMarketingNotes}`
          : partnerMarketingNotes
        : formValues.partnerMarketingNotes,
    });

    dispatch(postWithState, {
      action: SR_API_ACTION_PARTNER_UPDATE_MARKETING_LISTING,
      payload: {
        updates,
        marketingPartnerListingId: marketingPartnerListing.id,
      },
      onSuccess: () => {
        this.setState({
          shouldShowSuccessModal: true,
        });
        setTimeout(() => {
          onSubmit();
        }, 1000);
      },
      onError: (error) => {
        log.error(error);
      },
    });
  };

  _getFormFields = () => {
    return [
      {
        id: 'availableForSetupDate',
        title: 'Date available for setup?',
        type: 'date_picker',
        properties: {
          placeholder: 'MM/DD/YYYY',
          dateFormat: 'MM/DD/YYYY',
        },
        validations: ['required', 'noPastDates'],
      },
      {
        id: 'partnerMarketingNotes',
        title: 'Notes for the Sunroom team',
        titleSecondary: '(optional)',
        properties: {
          placeholder: 'Write here...',
        },
        type: 'long_text',
      },
    ];
  };

  render() {
    const { marketingPartnerListing, onBack } = this.props;

    const { shouldShowSuccessModal, shouldShowLoadingScreen } = this.state;

    if (shouldShowLoadingScreen) {
      return <div className="loading-gif" />;
    }

    return (
      <Formik
        ref={(formik) => {
          this.formik = formik;
        }}
        validate={(values) => {
          const formFields = this._getFormFields();
          return createFormValidationFn(formFields)(values);
        }}
        onSubmit={(formValues) => {
          this._onSubmit(formValues);
        }}
      >
        {(formikBag) => {
          return (
            <>
              <Form className="form">
                <SrPartnerPageV2
                  onBack={onBack}
                  navbarTitle={getListingFullAddressString(marketingPartnerListing.listing)}
                  pageHeader="Bring back on market"
                  headerSize={SR_PARTNER_PAGE_V2_FONT_SIZE_SMALL}
                  pageSubtitle="What would you like us to know about how it was resolved?"
                >
                  <SrBox
                    backgroundColor="#ffffff"
                    borderRadius="14px"
                    padding="22px 19px 26px 19px"
                  >
                    {this._getFormFields({
                      values: formikBag.values,
                    }).map((formField, index) => (
                      <SrFormikField
                        formField={formField}
                        formikBag={formikBag}
                        theme={SR_FIELD_THEME_ADOBE}
                        margin={index === 0 ? '0px' : null}
                        key={formField.id}
                      />
                    ))}
                  </SrBox>
                </SrPartnerPageV2>
                <SrStaticFooter>
                  <SrText
                    display="block"
                    lineHeight="25px"
                    font="greycliff"
                    color="grey600"
                    fontSize="13px"
                    weight="500"
                  >
                    Updates can take 24 hours to syndicate
                  </SrText>
                  <SrFooterButton disabled={!formikBag.isValid} hasBoxShadow={formikBag.isValid}>
                    Submit Property For Leasing
                  </SrFooterButton>
                </SrStaticFooter>
              </Form>
              {shouldShowSuccessModal && (
                <SrSimpleMessageModal
                  iconUrl="/images/checkmark-circle-large-green.svg"
                  headline="Saved!"
                  maxWidth="375"
                  minWidth="320"
                  theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
                />
              )}
            </>
          );
        }}
      </Formik>
    );
  }
}

SrPartnerBringBackOnMarketForm.displayName = 'SrPartnerBringBackOnMarketForm';

export default SrPartnerBringBackOnMarketForm;
